import {
  ThunderboltOutlined,
  StarFilled,
  TrophyOutlined,
  HeartOutlined,
  HomeOutlined,
  ToolOutlined,
  ShoppingOutlined,
} from '@ant-design/icons';
import Layout from './components/Layout';
import './BatilinkLanding.css';

const professionalTypes = [
  {
    icon: <HomeOutlined />,
    title: 'Architectes',
    description: 'Architectes professionnels pour la conception et la supervision de vos projets',
  },
  {
    icon: <ToolOutlined />,
    title: 'Artisans',
    description: 'Plombiers, électriciens, peintres et autres artisans qualifiés pour tous vos travaux',
  },
  {
    icon: <ShoppingOutlined />,
    title: 'Fournisseurs',
    description: 'Fournisseurs de matériaux de construction et équipements de qualité',
  },
];

function AboutUs() {
  return (
    <Layout>
      <section className="about-section about-section-top" id="about-section" style={{ paddingTop: 60 }}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Qui Sommes-Nous ?</h2>
            <p className="section-subtitle">Découvrez BATILINK</p>
          </div>

          <div className="about-content">
            <div className="about-text-wrapper">
              <p className="about-text-simple">
                <strong>BATILINK</strong> est la meilleure plateforme digitale qui connecte tous les acteurs du BTP en Tunisie.
                L'objectif de BATILINK est de simplifier l'accès aux services du bâtiment en Tunisie tout en offrant aux professionnels une opportunité unique de digitaliser leur activité, de gagner en visibilité et de développer leur réseau de clients.
              </p>

              <p className="about-text-simple">
                Nous sélectionnons les meilleurs professionnels pour garantir un service de qualité supérieure. Notre plateforme offre une expérience rapide, fiable et transparente pour tous vos besoins en construction et rénovation.
              </p>
            </div>
          </div>

          <div className="trust-grid" style={{ marginTop: '48px' }}>
            <div className="trust-card">
              <div className="trust-icon"><ThunderboltOutlined /></div>
              <h3 className="trust-title">Rapidité</h3>
              <p className="trust-description">Trouvez un professionnel en moins d'une minute</p>
            </div>
            <div className="trust-card">
              <div className="trust-icon"><StarFilled /></div>
              <h3 className="trust-title">Qualité</h3>
              <p className="trust-description">Des professionnels vérifiés et notés par la communauté</p>
            </div>
            <div className="trust-card">
              <div className="trust-icon"><TrophyOutlined /></div>
              <h3 className="trust-title">Excellence</h3>
              <p className="trust-description">Les meilleurs professionnels pour un service de qualité supérieure</p>
            </div>
            <div className="trust-card">
              <div className="trust-icon"><HeartOutlined /></div>
              <h3 className="trust-title">Satisfaction</h3>
              <p className="trust-description">Votre satisfaction est notre priorité absolue</p>
            </div>
          </div>
        </div>
      </section>

      {/* Nos Professionnels */}
      <section className="professionals-section professionals-section-bg">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Nos Professionnels</h2>
            <p className="section-subtitle">BATILINK met en relation des professionnels qualifiés</p>
          </div>

          <div className="professionals-grid">
            {professionalTypes.map((type, index) => (
              <div key={index} className="professional-type-card">
                <div className="professional-icon">{type.icon}</div>
                <h3 className="professional-title">{type.title}</h3>
                <p className="professional-description">{type.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default AboutUs;
